<template>
  <div id="deviceEditUser" v-loading="isLoging">
    <el-dialog
      title="设备权限编辑"
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div id="shared" style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="form" :rules="rules" :model="form" label-width="200px" >

          <el-form-item label="设备编号" prop="deviceId">
            <el-input v-if="isEdit" v-model="form.deviceId" disabled></el-input>
            <el-input v-if="!isEdit" v-model="form.deviceId" clearable></el-input>
          </el-form-item>

          <el-form-item label="设备名称" prop="name">
            <el-input v-model="form.name" :readonly="true" clearable></el-input>
          </el-form-item>



          <el-form-item  label="公司或个人" prop="isRelatedJjsCompany" >
            <el-select v-model="form.isRelatedJjsCompany" style="float: left; width: 100%" >
              <el-option key="1" label="公司" :value="1"></el-option>
              <el-option key="2" label="个人" :value="2"></el-option>
            </el-select>
          </el-form-item>
          


          <!-- 公司 multiple （多选） collapse-tags （收缩）-->
          <el-form-item label="管船" prop="companyName" v-if="form.isRelatedJjsCompany==1">
            <el-select v-model="form.companyId"  
              placeholder="请选择"  style="float: left; width: 100%"
              clearable
              @change="selectShipList">
              <el-option
                v-for="item in companyList"
                :key="item.companyId"
                :label="item.companyName"
                :value="item.companyId">
              </el-option>
            </el-select>
            <!-- <el-select v-model="form.companyName" style="float: left; width: 100%" >
              <el-option key="公司" label="公司" value="1"></el-option>
              <el-option key="个人" label="个人" value="2"></el-option>
            </el-select> -->
            <!-- <el-input  v-model="form.companyName" clearable></el-input> -->
          </el-form-item>

          
          <!-- 公司 multiple （多选） collapse-tags （收缩）-->
          <el-form-item label="船务" prop="shipCompanyName" v-if="form.isRelatedJjsCompany==1">
            <el-select v-model="form.shipCompanyId"  
              placeholder="请选择"  style="float: left; width: 100%"
              clearable
              @change="selectShipList">
              <el-option
                v-for="item in companyList"
                :key="item.companyId"
                :label="item.companyName"
                :value="item.shipCompanyId">
              </el-option>
            </el-select>
            <!-- <el-select v-model="form.companyName" style="float: left; width: 100%" >
              <el-option key="公司" label="公司" value="1"></el-option>
              <el-option key="个人" label="个人" value="2"></el-option>
            </el-select> -->
            <!-- <el-input  v-model="form.companyName" clearable></el-input> -->
          </el-form-item>


          <el-form-item label="个人" prop="userName" v-if="form.isRelatedJjsCompany==2">
            <el-select v-model="form.userId" placeholder="请选择"  style="float: left; width: 100%">
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="船舶或者岸基" prop="shipName"  v-if="form.isRelatedJjsCompany==1">
            <el-select v-model="form.shipId" 
              placeholder="请选择"  style="float: left; width: 100%" >
              <el-option
                v-for="item in shipList"
                :key="item.shipId"
                :label="item.shipName || item.mmsi"
                :value="item.shipId">
              </el-option>
            </el-select>
          </el-form-item>


          
          <el-form-item label="状态" prop="status" >
            <el-select v-model="form.status" placeholder="请选择" style="float: left; width: 100%" >
              <el-option key="1" label="开启" :value="1"></el-option>
              <el-option key="2" label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" clearable maxlength="100"></el-input>
          </el-form-item>

          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" >确认</el-button>
              <el-button @click="close">取消</el-button>
            </div>

          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MediaServer from '../service/MediaServer'
export default {
  name: "deviceEditUser",
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      hostNames:[],
      mediaServerList: [], // 滅体节点列表
      mediaServerObj : new MediaServer(),
      form: {},
      formRest: {},
      isEdit: false,
      rules: {
        deviceId: [{ required: true, message: "请输入设备编号", trigger: "blur" }]
      },



      companyList : [] ,
      userList : [] ,
      selectedUserValue : {}  ,
      selectedCompanyValue : {} ,
      shipList: [],


    };
  },

  methods: {
    openDialog: function (row, callback) {
      // companyId: "eca3392d483d497fac058c3c92832bc0,-" 
      // shipCompanyId: "-,65727c35533b152ac51e9e20"

      this.loadCompanyList();
      this.loadUserList();
      console.log( 10000000 )
      console.log(row)
      


      console.log( 10000000 )
      console.log(row)
      this.showDialog = true;
      this.isEdit = false;
      if (row) {
        this.isEdit = true;
      }
      this.form = {};
      this.listChangeCallback = callback;
      if (row != null) {
        this.form = row;
      }

    },
    /**
     *获取公司信息
     */
    // loadUserListByCompanyId: function (){
    //   // 这里模拟异步获取数据
    //   setTimeout(() => {
    //     this.companyList = [
    //       { companyId: 'eca3392d483d497fac058c3c92832bc0', companyName: '重庆金睛兽物流科技有限公司' },
    //       { companyId: 'd012a8174b664a078d567305e85e0a30', companyName: '金睛兽' },
    //       // 更多选项...
    //     ];
    //   }, 1000);
    // },
    
            
    loadCompanyList: function () {
      let that = this;
      // if (typeof (this.$route.params.deviceId) == "undefined") return;
      this.$axios({
        method: 'post',
        url: `/api/jjsCompany/getCompanyAndShipList`,
        params: {
        }
      }).then( (res)=> {
        if (res.data.code === 0) {

          console.log( "加载 loadCompanyList " ) ;
          console.log( that.companyList ) ;

          console.log( "加载 loadCompanyList " ) ;
          let companyIdSp = "" ;
          let shipCompanyIdSp = "" ;
          if( this.form.companyId ){
            companyIdSp =  this.form.companyId ;
          }
          if( this.form.shipCompanyId ){
            shipCompanyIdSp = this.form.shipCompanyId ;
          }
          let uidCompanyIdIn = companyIdSp ;
          if( !companyIdSp ){
            uidCompanyIdIn = shipCompanyIdSp ;
          }

          that.companyList = res.data.data;
          that.companyList.forEach(e => {
            
          if( e.companyId == uidCompanyIdIn ){
              /**
               * 获取 companyList 第一个，然后查询
               */
              that.shipList.push( {shipId:"岸基",shipName:"岸基"} );
              e.shipList.forEach( eIn=>{
                that.shipList.push( eIn );
              } )
            }
          });

          console.log( this.companyList ) ;
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

        
    loadCompanyListOld: function () {
      let that = this;
      // if (typeof (this.$route.params.deviceId) == "undefined") return;
      this.$axios({
        method: 'post',
        url: `/api/jjsCompany/getCompanyAndShipList`,
        params: {
        }
      }).then( (res)=> {
        if (res.data.code === 0) {
          // console.log( res ) ;
          // this.companyList.push( { shipCompanyId :'' , companyId: 'd012a8174b664a078d567305e85e0a30', companyName: '金睛兽' , uid:'' } );
          console.log( "加载 loadCompanyList " ) ;
          let companyIdSp = "" ;
          let shipCompanyIdSp = "" ;
          if( this.form.companyId ){
            companyIdSp = (this.form.companyId+"").split(",")[0];
            if( companyIdSp == "-"){
              companyIdSp = "";
            }
          }
          if( this.form.shipCompanyId ){
            shipCompanyIdSp = (this.form.shipCompanyId+"").split(",")[0];
            if( shipCompanyIdSp == "-"){
              shipCompanyIdSp = "";
            }
          }
          let uidCompanyIdIn = companyIdSp + "_" + shipCompanyIdSp ;
          that.companyList = res.data.data;
          that.companyList.forEach(e => {
            // e.ptzType = e.ptzType + "";
            // that.$set(e, "edit", false);
            // that.$set(e, "location", "");
            // if (e.customLongitude && e.customLatitude) {
            //   that.$set(e, "location", e.customLongitude + "," + e.customLatitude);
            // }else if (e.longitude && e.latitude) {
            //   that.$set(e, "location", e.longitude + "," + e.latitude);
            // }
            let companyIdIn  ;
            if ( ! e.companyId ){
              companyIdIn = "" ;
            }else{
              companyIdIn = e.companyId ;
            }
            let shipCompanyIdIn ;
            if ( ! e.shipCompanyId ){
              shipCompanyIdIn = "" ;
            }else{
              shipCompanyIdIn = e.shipCompanyId ;
            }
            e.uidCompanyId = companyIdIn + "_" + shipCompanyIdIn ;
            // this.companyList.push(  { 
            //   shipCompanyId :e.shipCompanyId , 
            //   companyId: e.companyId, 
            //   companyName: e.companyName , 
            //   uidCompanyId: e.companyId + "_" + e.shipCompanyId }  ) ;
            console.log ( " e.uidCompanyId " +  e.uidCompanyId  );
            console.log ( " uidCompanyIdIn " +  uidCompanyIdIn  );
            if( e.uidCompanyId == uidCompanyIdIn ){
              /**
               * 获取 companyList 第一个，然后查询
               */
              that.shipList.push( {shipId:"岸基",shipName:"岸基"} );
              e.shipList.forEach( eIn=>{
                that.shipList.push( eIn );
              } )
            }
          });

          

          console.log( this.companyList ) ;
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    loadUserList: function (){
      // 这里模拟异步获取数据
      setTimeout(() => {
        this.userList = [
          { userId: 'userId001', userName: '张三' },
          { userId: 'userId002', userName: '李四' },
        ];
      }, 1000);
    },



    /**
     * 选择船舶数据
     */
    selectShipList : function ( val ){
      console.log("selectShipList : " + val );
      if( val ){
        val = val + "" ;
        val = val.split(",")[0]; 
        this.companyList.forEach(e => {
          if( e.uidCompanyId == val ){
            this.shipList = [] ;
            this.shipList.push( {shipId:"岸基",shipName:"岸基"} );
            e.shipList.forEach( eIn=>{
              this.shipList.push( eIn );
            } )
            return;
          }
        })
      }else{
        this.shipList = [] ;
      }
      
    },

    onSubmit: function () {
      console.log("onSubmit");
      // console.log(this.form);
      // console.log( this.companyList ) ;
      // console.log( this.userList ) ;
      // console.log( this.form.isRelatedJjsCompany ) ;
      // console.log( this.form.selectedUserValue ) ;
      // console.log( this.form.selectedCompanyValue ) ;

      /**
       * 转存请求对象 
       */
      this.formRest.remark = this.form.remark ;
      this.formRest.status = this.form.status ;
      this.formRest.deviceId = this.form.deviceId ;
      this.formRest.isRelatedJjsCompany = this.form.isRelatedJjsCompany ;
      // 重置默认选择
      this.formRest.companyName = null
      this.formRest.userName = null
      console.log( this.form );
      // 循环遍历 userList 和 companyList 
      if ( this.form.isRelatedJjsCompany == 1 ){
        // 公司类型
        this.formRest.userId = null;
        this.form.userId = null;
        this.formRest.userName = null;
        this.form.userName = null;
      }else if( this.form.isRelatedJjsCompany == 2 ){
        // 个人
        this.formRest.uidCompanyId = null;
        this.form.uidCompanyId = null;
        this.formRest.companyId = null;
        this.form.companyId = null;
        this.formRest.companyName = null;
        this.form.companyName = null;
        this.formRest.shipName = null;
        this.form.shipName = null;
      }else{
        this.formRest.userId = null;
        this.form.userId = null;
        this.formRest.uidCompanyId = null;
        this.form.uidCompanyId = null;
        this.formRest.companyId = null;
        this.form.companyId = null;
        this.formRest.companyName = null;
        this.form.companyName = null;
        this.formRest.shipId = null;
        this.form.shipId = null;
        this.formRest.shipName = null;
        this.form.shipName = null;
      }

      if(  this.form.companyId != null ||  this.form.shipCompanyId != null ){
        this.formRest.companyId = this.form.companyId ;
        this.formRest.shipCompanyId = this.form.shipCompanyId ;
        this.formRest.shipId = this.form.shipId ;
        if( this.formRest.shipId ){
          this.shipList.forEach( e => {
            if( this.formRest.shipId == e.shipId ){
              this.formRest.shipName = e.shipName ;
              this.formRest.mmsi = e.mmsi ;
            }
          })
        }
        if( this.form.companyId != null  ){
          this.companyList.some(e => {
            if( e.companyId == this.form.companyId || e.shipCompanyId == this.form.companyId ){
              this.formRest.companyName = e.companyName ;
              return true ;
            }
          })
        }
        if( this.form.shipCompanyId != null ){
          this.companyList.some(e => {
            if( e.companyId == this.form.shipCompanyId || e.shipCompanyId == this.form.shipCompanyId ){
              this.formRest.shipCompanyName = e.companyName ;
              return true ;
            }
          })
        }
        
        // ------------------- 

      }

      if(  this.form.userId != null ){
        this.formRest.userId = this.form.userId ;
        this.userList.some(e => {
          if (e.userId == this.form.userId) {
            this.formRest.userName = e.userName ;
            return true ; 
          }
        });
      }
      

      // this.form.subscribeCycleForCatalog = this.form.subscribeCycleForCatalog||0
      // this.form.subscribeCycleForMobilePosition = this.form.subscribeCycleForMobilePosition||0
      // this.form.mobilePositionSubmissionInterval = this.form.mobilePositionSubmissionInterval||0
      // if (this.form.mobilePositionSubmissionInterval === 0) {
      //   this.form.mobilePositionSubmissionInterval = 5
      // }
      this.$axios({
        method: 'post',
        url:`/api/device/upgrade/devices/updateDeviceCompanyUser`,
        // params 拼接和Data里面都有
        data: this.formRest
      }).then((res) => {
        console.log(res.data)
        if (res.data.code === 0) {
          this.listChangeCallback()
        }else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    close: function () {
      this.showDialog = false;
      this.$refs.form.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/deviceEditUser.vue